module.exports = __webpack_public_path__ + "img/SqualoSport-interno10.2bbd9ac3.jpeg";